module.exports = __webpack_public_path__ + "static/img/mould5-1.52b80b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould5-1.png
// module id = eaS0
// module chunks = 3